package com.nonopn.skydome.common.app.pages.densities

import androidx.compose.runtime.Composable

import com.nonopn.skydome.common.app.api.impl.ApiInterface
import com.nonopn.skywatcher.design.widgets.abslists.AbstractLists

import eu.codlab.viewmodel.rememberViewModel

@Composable
fun DensitiesScreen(
    currentInterface: ApiInterface,
    onNavigateKeraunic: ((projectUuid: String, projectName: String, lat: Double, lon: Double) -> Unit)? = null,
    onNavigateCertNsg: ((projectUuid: String, projectName: String, lat: Double, lon: Double) -> Unit)? = null,
    onNavigateLightningCertificates: (() -> Unit)? = null,
) {
    val model = rememberViewModel { DensitiesModel(currentInterface) }

    AbstractLists(
        model = model,
        renderElement = { _, holder ->
            RenderDensityActivity(
                project = holder.project,
                activities1Km = holder.less1Km,
                activities2Km = holder.less2Km,
                onNavigateKeraunic = onNavigateKeraunic,
                onNavigateCertNsg = onNavigateCertNsg,
                onNavigateLightningCertificates = onNavigateLightningCertificates,
            )
        }
    )
}
